<template>
    <v-container>
        <v-row dense id="dash_page">
            <v-col cols="4" lg="4" md="8" sm="12">
                <v-select name="users" class="" @change="get_user_stats" v-model="search.client_id"
                          :items="users" :label="$t('users.select')" item-text="lastname"
                          item-value="id" outlined clearable>
                    <template slot="selection" slot-scope="data">
                        <!-- HTML that describe how select should render selected items -->
                        {{ data.item.name }} - {{ data.item.lastname }}
                    </template>
                    <template slot="item" slot-scope="data">
                        <!-- HTML that describe how select should render items when the select is open -->
                        {{ data.item.name }} - {{ data.item.lastname }}
                    </template>
                </v-select>
            </v-col>
            <v-col cols="4" lg="4" md="8" sm="12">
                <v-menu v-model="date_from_menu" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                        <v-text-field name="date_from" type="text" class="custom_field"
                                      :value="$Helper.methods.formatDate(search.date_from)"
                                      :label="$t('general.date_from')" outlined readonly
                                      v-on="on">
                        </v-text-field>
                    </template>
                    <v-date-picker v-model="search.date_from" no-title @input="get_user_stats"
                                   @change="date_from_menu = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="4" lg="4" md="8" sm="12">
                <v-menu v-model="date_to_menu" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                        <v-text-field name="date_to" type="text" class="custom_field"
                                      :value="$Helper.methods.formatDate(search.date_to)"
                                      :label="$t('general.date_to')" outlined readonly
                                      v-on="on">
                        </v-text-field>
                    </template>
                    <v-date-picker v-model="search.date_to" no-title @input="get_user_stats"
                                   @change="date_to_menu = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
        <v-row dense id="dash_page">
            <v-col cols="12">
                <v-card class="mb-2">
                    <v-col cols="12" lg="12" md="4" sm="6" xs="6">
                        <v-chart class="chart" :option="pie_options"/>
                    </v-col>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {use} from "echarts/core";
    import {SVGRenderer} from "echarts/renderers";
    import {PieChart} from "echarts/charts";
    import {
        TitleComponent,
        TooltipComponent,
        LegendComponent
    } from "echarts/components";
    import VChart, {THEME_KEY} from "vue-echarts";


    use([
        SVGRenderer,
        PieChart,
        TitleComponent,
        TooltipComponent,
        LegendComponent
    ]);


    export default {
        components: {
            VChart
        },
        provide: {
            [THEME_KEY]: "light"
        },
        data: self => ({
            users: [],
            user_stats: [],
            date_from_menu: false,
            date_to_menu: false,
            search: {
                client_id: 0,
                date_from: null,
                date_to: null
            },
            pie_options: {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} € Total"
                },
                legend: {
                    orient: "horizontal",
                    left: "left",
                    data: []
                },
                series: [
                    {
                        name: "User Actions",
                        type: "pie",
                        radius: "55%",
                        center: ["50%", "60%"],
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)"
                            }
                        }
                    }
                ]
            }
        }),
        async mounted() {
            let response = await this.$store.dispatch('apiRequest', {
                method: 'get', url: 'user_list'
            });
            this.users = response.data;

            this.setDefaultSearchCriteria();
        },
        methods: {
            async get_user_stats() {
                this.pie_options.legend.data = [];
                this.pie_options.series[0].data = [];

                if (this.search.client_id) {
                    let response = await this.$store.dispatch('apiRequest', {
                        method: 'get',
                        url: 'user_stats',
                        params: {
                            user_id: this.search.client_id,
                            date_from: this.search.date_from,
                            date_to: this.search.date_to
                        }
                    });

                    this.user_stats = response.data;

                    // Loop through the response data in order to extract the stats and populaste the charts
                    for (const item_type in this.user_stats) {
                        if (this.user_stats.hasOwnProperty(item_type)) {
                            for (const action in this.user_stats[item_type]) {
                                if (parseInt(this.user_stats[item_type][action]['count']) > 0) {
                                    var action_data = {
                                        value: this.user_stats[item_type][action]['total_amount'],
                                        name: this.user_stats[item_type][action]['friendly_name'],
                                        label: {
                                            alignTo: 'edge',
                                            formatter: this.user_stats[item_type][action]['friendly_name'] + ': ' + this.user_stats[item_type][action]['total_amount'] + ' € Total'
                                        }
                                    };
                                    this.pie_options.series[0].data.push(action_data);
                                    this.pie_options.legend.data.push(this.user_stats[item_type][action]['friendly_name']);
                                }
                            }
                        }
                    }
                }
            },
            // set default values for search form
            setDefaultSearchCriteria() {
                // set default search dates
                let date = new Date();
                this.search.date_to = date.toISOString().substring(0, 10);
                date.setDate(date.getDate() - 500);
                this.search.date_from = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
        }
    }
</script>

<style scoped>
    .chart {
        height: 400px;
    }

</style>
